import Listener from './service';

export default new Listener();
